// material
import {
  Stack,
  Box,
  TextField,
  Autocomplete,
  Card,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useState } from 'react';
import { get, isEmpty } from 'lodash';
// components
import Scrollbar from '../components/Scrollbar';
import Page from '../components/Page';

// store
import { api as stockApi } from '../store/domains/stock';

export default function Hierarchy() {
  const [partnerValue, setPartnerValue] = useState('');
  const [partnerId, setPartnerId] = useState('');
  const [inputValue, setInputValue] = useState('');

  const { data: posManagerOrganizations } = stockApi.useGetOrganizations(null);
  const { data: partnerData } = stockApi.useGetOrganizationsTree(partnerId, {
    skip: !partnerId,
  });

  const handleChange = (value) => {
    setPartnerValue(value.label);
    setPartnerId(value.id);
  };

  const subOrganizations = get(partnerData, 'data.subOrganizations');
  const tradePoints = get(partnerData, 'data.tradePoints');
  const users = get(partnerData, 'data.users');
  const renderTable = (data) => (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {Object.entries(data)
              .filter(([, val]) => typeof val !== 'object')
              .map(([item], index) => (
                <TableCell key={index} align="left">
                  {item}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.values(data)
            .filter((it) => typeof it !== 'object')
            .map((item, index) => (
              <TableCell key={index} align="left">
                {item}
              </TableCell>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
  const renderTradePoints = (point) => (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {Object.keys(point[0]).map((item, index) => (
              <TableCell key={index} align="left">
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {point?.map((item, index) => (
            <TableRow key={index}>
              {Object.entries(item).map(([key, value], index) => {
                if (typeof value !== 'object') {
                  return (
                    <TableCell key={index} align="left">
                      {item[key]}
                    </TableCell>
                  );
                }
                return (
                  <TableCell key={index} align="left">
                    {value?.title}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderSubOrg = (subOrgs) => {
    const subOrganizationsTrade = get(subOrgs, 'tradePoints');
    const subOrganizationsUser = get(subOrgs, 'users');
    return (
      <>
        <Typography variant="h3" color="green" padding={3}>
          Sub Dealer
        </Typography>
        {renderTable(subOrgs)}
        {!isEmpty(subOrganizationsTrade) && (
          <>
            <Typography variant="h4" color="green" padding={3}>
              Trade Points
            </Typography>
            {renderTradePoints(subOrganizationsTrade)}
          </>
        )}{' '}
        {!isEmpty(subOrganizationsUser) && (
          <>
            <Typography variant="h4" color="green" padding={3}>
              Users
            </Typography>
            {renderTradePoints(subOrganizationsUser)}
          </>
        )}
      </>
    );
  };
  return (
    <Page title="User">
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Stack sx={{ my: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Box display="flex" sx={{ mx: 2 }}>
            <Autocomplete
              value={partnerValue}
              onChange={(_, newValue) => {
                handleChange(newValue);
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              options={posManagerOrganizations || []}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params} label="Select Partner" />}
            />
          </Box>
        </Stack>
      </Stack>
      {partnerData && (
        <Card>
          <Scrollbar>
            <Typography variant="h2" color="green" padding={3}>
              Dealer
            </Typography>
            {renderTable(partnerData?.data)}
            {!isEmpty(tradePoints) && (
              <>
                <Typography variant="h2" color="green" padding={3}>
                  Trade Points
                </Typography>
                {renderTradePoints(tradePoints)}
              </>
            )}{' '}
            {!isEmpty(users) && (
              <>
                <Typography variant="h2" color="green" padding={3}>
                  Users
                </Typography>
                {renderTradePoints(users)}
              </>
            )}
            {!isEmpty(subOrganizations) && <>{subOrganizations?.map(renderSubOrg)}</>}
          </Scrollbar>
        </Card>
      )}
    </Page>
  );
}
